import { createContext, useEffect, useState,useRef } from 'react';
import { useHistory } from 'react-router-dom';

export const HistoryContext = createContext({
  historyCount: 1,
  checkHistory: () => {},
  increseHistoryCount: () => {},
  decreaseHistoryCount: () => {},
  initHistoryCount: () => {},
})

const HistoryProvider = ({ children }) => {
  const history = useHistory()

  const historyContext = useRef({ historyCount : 1 });

  const trackHistory = () => {
    history.listen((location, action) => {
      if(action === 'POP') {
        --historyContext.current.historyCount;
      } else if (action === 'PUSH') {
        ++historyContext.current.historyCount;
      }  
    })
  }

  useEffect(() => {
    trackHistory();
  }, [])

  return (
    <HistoryContext.Provider value={historyContext.current}>
      {children}
    </HistoryContext.Provider>
  )
}

export default HistoryProvider;